import React from 'react';
import { useFirstMountState } from 'react-use';
export function useApi(url, enable = true, jsonPostData = '') {
    const [data, setData] = React.useState();
    const [error, setError] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [complete, setComplete] = React.useState(false);
    const isFirstMount = useFirstMountState();
    React.useEffect(() => {
        if (isFirstMount || !enable) {
            return;
        }
        doAsync();
        async function doAsync() {
            try {
                setLoading(true);
                const res = await fetch(url, {
                    method: jsonPostData !== '' ? 'POST' : 'GET',
                    body: jsonPostData !== '' ? jsonPostData : null,
                    headers: {
                        'content-type': 'application/json',
                    },
                });
                if (!res.ok) {
                    setData(undefined);
                    setError(new Error(res.statusText));
                    setLoading(false);
                    return;
                }
                const data = (await res.json());
                setData(data);
                setError(undefined);
                setLoading(false);
                setComplete(true);
            }
            catch (error) {
                setData(undefined);
                setError(error);
                setLoading(false);
            }
        }
    }, [enable, url, jsonPostData]);
    return { data, error, loading, complete };
}
